import { SwiperSlide } from "swiper/react";
import {
  LearningCarousel,
  LearningSimilarCourse,
} from "@kunduz/feature-learning-ui";
import styles from "./learningSimilarCourses.module.scss";
import { useSimilarCourses } from "../../hooks/useSimiliarCourses";
import { LoadingSkeleton } from "@kunduz/ui";
import { getContentUrl, ReservedWords } from "@kunduz/utility-common";

const LearningSimilarCoursesLoading = () => (
  <LoadingSkeleton style={{ width: "100%", height: 375 }} />
);

export const LearningSimiliarCourses = (props: Props) => {
  const { id, type } = props;
  const { similarCourses, similarCoursesLoading } = useSimilarCourses({
    id,
    type,
  });

  if (similarCoursesLoading) {
    return <LearningSimilarCoursesLoading />;
  }

  const reservedWord =
    type == "modules"
      ? ReservedWords.TR_CONTENT_MODULE
      : ReservedWords.TR_CONTENT_PATH_DETAIL;

  return (
    <div className={styles["container"]}>
      <div className={styles["title"]}>{props.title}</div>
      <LearningCarousel
        isMobile={props.isMobile}
        perView={3}
        spaceBetween={16}
        swipeItemsLength={similarCourses?.length}
      >
        {similarCourses?.map((course) => (
          <SwiperSlide key={course.id}>
            <LearningSimilarCourse
              logo={course.logo}
              courseName={course.name}
              description={course.seo_meta?.sub_title}
              numberOfSubjectsLabel={`${course.stats_meta?.number_of_subjects} ${props.numberOfSubjectsLabel}`}
              numberOfVideosLabel={`${course.stats_meta?.number_of_videos} ${props.numberOfVideosLabel}`}
              url={getContentUrl({
                lang: props.lang,
                contentType: reservedWord,
                segments: [course.slug],
              })}
              goPathLabel={props.goPathLabel}
              linkAs={props.linkAs}
            />
          </SwiperSlide>
        ))}
      </LearningCarousel>
    </div>
  );
};

interface Props {
  isMobile: boolean;
  title: string;
  numberOfSubjectsLabel: string;
  numberOfVideosLabel: string;
  goPathLabel: string;
  id: number;
  type: "paths" | "modules";
  lang: "tr" | "en";
  linkAs?: React.ElementType;
}
